import { Component, OnInit } from '@angular/core';
import { LangService } from 'src/app/services/lang/lang.service';
import { environment } from 'src/environments/environment';
import { SsoService } from '../../../services/sso/sso.service';

@Component({
  selector: 'app-appbar',
  templateUrl: './appbar.component.html',
  styleUrls: ['./appbar.component.css']
})

export class AppbarComponent implements OnInit {
  public environment = environment;

  constructor(
    public ssoService: SsoService,
    public langService: LangService) { }

  async ngOnInit(): Promise<void> {
  }

  public endAppSession(): void {
    this.ssoService.endAppSession();
    window.location.replace(environment.webSSO);
  }

  public getEnvironment(): string {
    switch (environment.webSSO) {
      case 'https://my.movisat.com':
        return '* PRODUCCIÓN *';
      case 'https://preproduccion.my.movisat.com':
        return '* PRE-PRODUCCIÓN *';
      default:
        return '* DESARROLLO *';
    }
  }

}
